import { FormEvent, useState } from 'react';
import type { MeResponse } from '@kassa/shared';
import { api, ApiError } from '../api';

interface Props {
  me: MeResponse;
  onDone: (me: MeResponse) => void;
  onLogout: () => void;
  /** Hesabım-dan açılanda: geri qayıt (məcburi ilk girişdə yoxdur) */
  onCancel?: () => void;
}

// Müvəqqəti parolla girilib: yeni parol qoyulana qədər başqa ekran açılmır (KT-41).
export function ChangePassword({ me, onDone, onLogout, onCancel }: Props) {
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password !== repeat) {
      setError('Yeni parollar eyni deyil');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      onDone(await api.changePassword({ currentPassword: current, newPassword: password }));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Şəbəkə xətası. Yenidən cəhd edin.');
      setCurrent('');
      setPassword('');
      setRepeat('');
    } finally {
      setBusy(false);
    }
  }

  async function logout() {
    await api.logout().catch(() => undefined);
    onLogout();
  }

  return (
    <div className="page-center">
      <form className="auth-form card" onSubmit={submit} noValidate>
        <div className="auth-heading">
          <h2>Yeni parol</h2>
          <span className="muted">{me.accountName}, müvəqqəti parolunuzu dəyişin. Bunu etmədən iş görmək olmur.</span>
        </div>
        <label className="field">
          Müvəqqəti (cari) parol
          <input name="current-password" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required disabled={busy} />
        </label>
        <label className="field">
          Yeni parol (ən azı 8 simvol)
          <input name="new-password" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={busy} />
        </label>
        <label className="field">
          Yeni parol (təkrar)
          <input name="repeat-password" type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required disabled={busy} />
        </label>
        {error && (
          <p className="bad" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="btn-primary" disabled={busy || !current || password.length < 8 || !repeat}>
          {busy ? 'Yadda saxlanılır…' : 'Parolu dəyiş'}
        </button>
        {onCancel && (
          <button type="button" className="link-btn" onClick={onCancel}>
            Geri
          </button>
        )}
        <button type="button" className="link-btn" onClick={logout}>
          Çıxış
        </button>
      </form>
    </div>
  );
}
